import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, IconButton, Stack, Typography, useMediaQuery } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { selectAutoPays, selectPaymentState, clearGetAutoPaysState, selectResidentDetails } from '../sagas/residentpaymentsSlice';
import RecurringCatalog from './RecurringComp';
import SpinnerWithNoConfirmation from '../../../shared/Modal/spinnerWithNoConfirmation';
import RecurringPaymentIcon from '../../../icons/RecurringPaymentIcon.svg';
import AddCardIcon from '../../../icons/addcard.png';
import MakePaymentModal, { ResPaymentType } from './MakePaymentModal';
import { useEffect, useState } from 'react';

export default function RecurringPayments(props: any) {
  const dispatch = useDispatch();
  const matchesMobile = useMediaQuery('(max-width:600px)');

  //local state
  const [openMakePaymentModal, setOpenMakePaymentModal] = useState(false);
  const [openAutopayDetails, setOpenAutopayDetails] = useState(false);

  //selectors
  const residentsDetails = useSelector(selectResidentDetails);
  const { isFetchingAutoPays, isAutoPaysFailed } = useSelector(selectPaymentState);
  const fetchedAutoPays = useSelector(selectAutoPays);

  const handleClickPayNow = () => {
    if (fetchedAutoPays && fetchedAutoPays.length > 0) {
      // disable creating new recurring pyment if there is at least one active autopay on record
      return;
    }
    setOpenMakePaymentModal(true);
  };

  // sort autopays
  let allAutoPays: any = [];
  if (fetchedAutoPays) allAutoPays = [...fetchedAutoPays].sort((a: any, b: any) => (a?.CreatedDate > b?.CreatedDate ? -1 : a?.CreatedDate < b?.CreatedDate ? 1 : 0));

  useEffect(() => {
    allAutoPays.length !== 0 && dispatch(clearGetAutoPaysState());
  }, [fetchedAutoPays, allAutoPays.length, dispatch]);

  useEffect(() => {
    isAutoPaysFailed && props.handleFailure();
  }, [isAutoPaysFailed, props]);

  return (
    <React.Fragment>
      {!matchesMobile ? (
        <Stack direction="column" justifyContent="start" alignItems="center">
          <div
            style={{
              display: 'flex',
              alignItems: 'start',
              justifyContent: 'start',
              width: '100%',
            }}
          >
            <Typography id="recurringTitle">
              Recurring Payments
              <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
              {allAutoPays && allAutoPays.length === 0 && (
                <IconButton sx={{ p: 0, m: 0, ml: 1 }} onClick={handleClickPayNow} id="icon-Btn-recurring">
                  <img style={{ cursor: 'pointer', width: '20px', height: '20px' }} src={AddCardIcon} alt="add card" id="recurring-btn-img" />{' '}
                </IconButton>
              )}
            </Typography>
          </div>

          {isFetchingAutoPays ? (
            <div style={{ marginTop: '50px' }}>
              <SpinnerWithNoConfirmation />
            </div>
          ) : allAutoPays && allAutoPays.length !== 0 ? (
            <Stack justifyContent="center" alignItems="center" spacing={2} sx={{ width: 270 }}>
              <RecurringCatalog methods={allAutoPays} openAutopayDetails={openAutopayDetails} setOpenAutopayDetails={setOpenAutopayDetails} />
            </Stack>
          ) : allAutoPays && allAutoPays.length === 0 ? (
            <Stack justifyContent="center" alignItems="center" spacing={2}>
              <img src={RecurringPaymentIcon} alt="history" width="194px" height="121px" />
              <Typography>Recurring Payments</Typography>
            </Stack>
          ) : (
            <></>
          )}
        </Stack>
      ) : (
        <Grid container display="flex">
          <Grid item xs={10.5}>
            <Grid ml={0.5} item sx={{ width: '100%', display: 'flex' }}>
              <Typography onClick={handleClickPayNow} id="recurringTitle">
                Recurring Payments <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />{' '}
              </Typography>
            </Grid>
            {isFetchingAutoPays ? (
              <Grid item mt={6} ml={2} sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <SpinnerWithNoConfirmation />
              </Grid>
            ) : allAutoPays && allAutoPays.length !== 0 ? (
              <RecurringCatalog methods={allAutoPays} />
            ) : (
              <Stack justifyContent="center" alignItems="center" spacing={2}>
                <img src={RecurringPaymentIcon} alt="history" width="194px" height="121px" />
                <Typography>Recurring Payments</Typography>
              </Stack>
            )}
          </Grid>
          {allAutoPays && allAutoPays.length === 0 && (
            <Grid item xs={1.5}>
              <IconButton onClick={handleClickPayNow} id="icon-Btn-recurring">
                <img style={{ cursor: 'pointer', width: '20px', height: '20px', position: 'absolute', top: 0 }} src={AddCardIcon} alt="add card" id="recurring-btn-img" />{' '}
              </IconButton>
            </Grid>
          )}
        </Grid>
      )}

      {openMakePaymentModal && (
        <MakePaymentModal open={openMakePaymentModal} residentsDetails={residentsDetails} currentTab={ResPaymentType.Recurring} closeCallback={() => setOpenMakePaymentModal(false)} />
      )}
    </React.Fragment>
  );
}
